import { cva, type VariantProps } from 'class-variance-authority';

/**
 * DegreeCardSimple CVA variants.
 * Border-radius 10px (--border-radius/m). Width is fluid; parent controls layout.
 */
export const degreeCardSimpleVariants = cva(
  'flex flex-col w-full rounded-md overflow-hidden',
  {
    variants: {
      border: {
        none: '',
        stroke: 'border border-neutral-200',
        shadow: 'border border-neutral-200 shadow-sm',
      },
    },
    defaultVariants: {
      border: 'shadow',
    },
  },
);

export type DegreeCardSimpleVariantProps = VariantProps<
  typeof degreeCardSimpleVariants
>;
